import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { MainFooter } from 'telia-front-react';
import { AppFooter } from '@teliaee/telia-megamenu';
import MenuStore from '@stores/MenuStore';

interface FooterProps {
  menuStore?: MenuStore;
}

@inject('menuStore')
@observer
class FooterContainer extends React.Component<FooterProps> {

  public render(): JSX.Element {
    return (
        <MainFooter>
          <AppFooter {...this.props.menuStore.getFooterProps()}/>
        </MainFooter>
    );
  }
}

export default FooterContainer;
